import React from "react";
import {
  TableManger,
  TABLES,
  TABLE_DISPLAY_NAME
} from "../../../managers/TableManger";
import {
  getSalaryHistoryColumnConfig,
  parseColumnConfig,
  parseVisibleColumnConfig
} from "../../configs/config";
import Utility, { deepClone } from "../../../utility/Utility";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import moment from "moment";
import {
  showLoader,
  removeLoader,
  DKDateRangePicker,
  DKIcons,
} from "deskera-ui-library";
import { COMPANY_DATE_FORMATS, DATE_FORMAT } from "../../../constants/Constant";
import EmployeeListService from "../../../services/EmployeeListService";
import { TenantService, TENANT } from "../../../managers/TenantManagerService";


class SalaryHistory extends React.Component {
  SalaryHistoryColumns = [];

  constructor(props) {
    super(props);

    this.SalaryHistoryColumns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_SALARY_HISTORY)));

    this.state = {
      history: {
        columnData: deepClone(this.SalaryHistoryColumns),
        rowData: [],
        filter: [],
        originalData: [],
      },
      pagination: {
        currentPage: 1,
        limit: 5,
        order: "desc",
        field: "updatedAt",
        tDate: moment().endOf("day").endOf("year").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        fromDate: moment().startOf("day").startOf("year").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      },
      salaryHistory: [],
      showDateRangePicker: false,
    };

  }

  componentDidMount() {
    this.loadSalaryHistory(this.state.pagination);
  }

  loadSalaryHistory(config) {
    showLoader();
    EmployeeListService.getEmployeeSalaryHistory(this.props.employeeData.userId, config).then((response) => {
      removeLoader();

      let rowData = [];
      rowData = getSalaryHistoryColumnConfig(response.employeeUpdateHistory);

      const history = {
        columnData: deepClone(this.SalaryHistoryColumns),
        rowData: rowData,
        filter: [],
        originalData: rowData,
      };

      this.setState({
        history: history,
        pagination: {
          ...this.state.pagination,
          currentPage: parseInt(response.filterConfig.page),
          totalPageCount: parseInt(response.filterConfig.totalPage),
        },
      });
    }, (error) => {
      this.setState({
        history: {
          columnData: deepClone(this.SalaryHistoryColumns),
          rowData: [],
          filter: [],
          originalData: [],
        },
        pagination: {
          ...this.state.pagination,
          currentPage: 1,
          limit: 5,
        },
        salaryHistory: [],
      });
      removeLoader();
    });
  }
  renderDateRangePicker = () => {
    return (
      <div className="position-absolute bg-white z-index-6 rounded border-m" style={{ top: 200, right: 25 }}>
        <DKDateRangePicker
          className="border shadow "
          color="#006641"
          startDate={moment(this.state.pagination.fromDate).toDate()}
          selectedStartDate={moment(this.state.pagination.fromDate).toDate()}
          selectedEndDate={moment(this.state.pagination.tDate).toDate()}
          onSelectDateRange={(startDate, endDate) => {
            if (startDate && endDate) {
              this.setState({
                showDateRangePicker: false
              }
              );
              this.state.pagination.currentPage = 1;
              this.setState({
                pagination: {
                  ...this.state.pagination,
                  tDate: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  fromDate: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                }
              }, () => {
                this.loadSalaryHistory(this.state.pagination);
              });
            }
          }}
          onClose={() => {
            this.setState({
              showDateRangePicker: false
            }
            );
          }}
        />
      </div>
    );
  }

  getDatePickerTitle = () => {
    return `${Utility.formatDate(moment(this.state.pagination.fromDate).format(DATE_FORMAT.IND), DATE_FORMAT.IND)} - ${Utility.formatDate(moment(this.state.pagination.tDate).format(DATE_FORMAT.IND), DATE_FORMAT.IND)}`;
  }
  onSort = (data) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        order: data.order.toLowerCase(),
      }
    },
      () => { this.loadSalaryHistory(this.state.pagination); }
    );
  }

  render() {
    return (

      <div
        className="column parent-width flex-1 parent-height"
        style={{ minHeight: 200 }}
      >
        {this.state.showDateRangePicker && this.renderDateRangePicker()}
        <div className="column parent-width mb-s position-relative flex-1 ">
          <DataGridHolderPayroll
            tableName={TABLES.PEOPLE_SALARY_HISTORY}
            displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_SALARY_HISTORY]}
            allowColumnEdit={false}
            allowColumnDelete={false}
            allowColumnShift={false}
            allowSearch={false}
            allowFilter={false}
            onRowDelete={() => { }}
            onRowEdit={() => { }}
            allowRowAdd={true}
            allowRowEdit={false}
            allowDataExport={false}
            gridData={this.state.history}
            onSearch={() => { }}
            onColumnAdd={() => { }}
            onFilter={() => { }}
            onRowAdd={() => { }}
            onPaginationClick={(requestedPageNumber) => {
              this.setState({
                pagination: {
                  ...this.state.pagination,
                  currentPage: requestedPageNumber,
                }
              }, () => {this.loadSalaryHistory(this.state.pagination);});              
            }}
            addButtonConfig={[
              {
                title: this.getDatePickerTitle(),
                icon: DKIcons.ic_calendar,
                className: "bg-white ml-s border-m",
                onClick: () => {
                  this.setState({
                    showDateRangePicker: true
                  });
                }
              }]}
            currentPage={this.state.pagination.currentPage}
            totalPageCount={this.state.pagination.totalPageCount}
            isActionEnabled={false}
            contextMenu={false}
            onStatusChange={() => { }}
            isMenuVisible={false}
            onRowUpdate={() => { }}
            onSort={this.onSort}
            dateFormat={COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))[0]?.value}
          />
        </div>
      </div>
    );
  }
}

export default SalaryHistory;
